import { Component, Inject } from "@angular/core";
import { StateService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmDialog } from "../../../shared/confirm-dialog.component";
import { PersonDataService } from "../../../core/persons.dataservice";
import * as dataCore from "../../../core/datacore";

@Component({
    selector: "crew-person-workplace",
    template: require('./person.workplace.component.html')
})
export class PersonWorkplaceComponent {

    FromDate: Date;

    constructor(
        @Inject(PersonDataService.Id) private personDataService: PersonDataService,
        @Inject("personWorkplace") public personWorkPlace: Nema.Crew.Model.PersonWorkplace,
        @Inject("workplaces") public workplaces: Nema.Crew.Model.Workplace[],
        private stateService: StateService,
        private dialog: MatDialog,
        @Inject('$log') private $log: ng.ILogService) {
        
        this.FromDate = dataCore.addTimezoneOffset(this.personWorkPlace.FromDate);
    }

    public entityName = "Person Workplace";

    public editStateName = "app.resources.persons.workplaces.edit";

    public listStateName = "app.resources.persons.detail";

    public edit(): void {
        this.stateService.go(this.editStateName, { personWorkplaceId: this.personWorkPlace.Id });
    }

    public delete(): void {

        var self = this;

        this.dialog
            .open(ConfirmDialog)
            .afterClosed()
            .subscribe(res => self.onDeleteEntity(self, res));
    }

    private onDeleteEntity(self: PersonWorkplaceComponent, shouldDelete?: boolean) {
        if (shouldDelete) {

            self.personDataService.removeMapping(this.personWorkPlace, () => { });

            self.personDataService
                .save(self.personWorkPlace.Person)
                .then(() => self.backToList())
                .catch(err => self.$log.error("Error deleting the entity.\n\nError is: " + err));
        }
    }

    public backToList(): void {
        this.stateService.go(this.listStateName, { id: this.personWorkPlace.PersonId });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons/workplaces/person.workplace.component.ts